var _circle, _circle2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgIllustrationPeople = function SvgIllustrationPeople(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "var(--color-disabled)",
    viewBox: "0 0 360 360",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 245.4,
    cy: 253.1,
    r: 55.6,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 245.4 253)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 106.6,
    r: 55.6,
    fill: "var(--secondary-fill)",
    transform: "rotate(-90 114 106.6)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--secondary-fill)",
    d: "m268 122.9 4.4-37.4 37.4 4.4-4.5 37.5zM50 276.4l8.3-36.8L95 248l-8.3 36.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M183 95.6c-48.7 0-88.4 39-88.4 86.8A87.7 87.7 0 0 0 183 269c48.7 0 88.4-39 88.4-86.7A87.7 87.7 0 0 0 183 95.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--color-white)",
    d: "M141.7 217.5q-2.1 0-3.5-1.5-1.5-1.4-1.5-3.5v-8.8a14 14 0 0 1 7-12 59 59 0 0 1 53.7 0q3.2 1.6 5 4.8 2 3.2 2 7.2v8.8q0 2.1-1.5 3.5-1.4 1.5-3.6 1.5zm68.4 0q1-.5 1.7-1.7.8-1.3.8-3.3v-10q0-4-2.3-8.9a20 20 0 0 0-6.9-8.2 60 60 0 0 1 21.3 6.3 22 22 0 0 1 6.2 5.1 9 9 0 0 1 2.1 5.7v10a5 5 0 0 1-5 5h-18ZM170.5 180q-7.5 0-12.8-5.3a18 18 0 0 1-5.3-12.8q0-7.5 5.3-12.8t12.8-5.3 12.8 5.3 5.3 12.8-5.3 12.8a18 18 0 0 1-12.8 5.3m46.8-18q0 7.5-5.3 12.7a18 18 0 0 1-12.8 5.3 31 31 0 0 1-8-1.1 27 27 0 0 0 5.6-17 29 29 0 0 0-5.6-17q2-.6 4-.9l4-.2q7.5 0 12.8 5.3t5.3 12.8Z"
  })));
};
export default SvgIllustrationPeople;